import React, { useState } from 'react';

const EventDetailsModal = ({ isOpen, event, onClose }) => {
  const [activeTab, setActiveTab] = useState('requestParameters');

  if (!isOpen || !event) return null;
  const formatJSON = (jsonString) => {
    try {
      if (typeof jsonString === 'string') {
        return JSON.stringify(JSON.parse(jsonString), null, 2);
      } else if (typeof jsonString === 'object') {
        return JSON.stringify(jsonString, null, 2);
      }
      return 'No data available';
    } catch (e) {
      return jsonString || 'No data available';
    }
  };

  const requestParameters = formatJSON(event.requestParameters);
  const responseElements = formatJSON(event.responseElements);

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>


        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                  Event Details: {event.eventName}
                </h3>
                
                <div className="mt-4">
                  <div className="flex border-b border-gray-200">
                    <button
                      className={`py-2 px-4 font-medium ${activeTab === 'requestParameters' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                      onClick={() => setActiveTab('requestParameters')}
                    >
                      Request Parameters
                    </button>
                    <button
                      className={`py-2 px-4 font-medium ${activeTab === 'responseElements' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                      onClick={() => setActiveTab('responseElements')}
                    >
                      Response Elements
                    </button>
                  </div>
                  
                  <div className="mt-4 max-h-96 overflow-auto">
                    <pre className="bg-gray-50 p-4 rounded-md text-sm overflow-x-auto">
                      {activeTab === 'requestParameters' ? requestParameters : responseElements}
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetailsModal;